import { Instant } from "@js-joda/core";
import type {
  StaffProfileResponseEmployment,
  StaffProfileResponseV3,
} from "./staff.service";

const toInstant = (isoInstant: string | null | undefined): Instant | null => {
  if (isoInstant == null) return null;

  try {
    return Instant.parse(isoInstant);
  } catch {
    return null;
  }
};

const findClosestUpcomingEmployment = (
  employments: StaffProfileResponseEmployment[],
  now: Instant,
): StaffProfileResponseEmployment | undefined => {
  let closestEmployment: StaffProfileResponseEmployment | undefined;
  let closestStartDate: Instant | null = null;

  for (const employment of employments) {
    const startDate = toInstant(employment.startDate);
    if (startDate == null || !startDate.isAfter(now)) continue;

    if (closestStartDate == null || startDate.isBefore(closestStartDate)) {
      closestEmployment = employment;
      closestStartDate = startDate;
    }
  }

  return closestEmployment;
};

/**
 * Picks employment for profile view: the active employment, or the closest
 * upcoming employment when the worker has no active one.
 */
export const toSelectedEmployment = (
  profile: StaffProfileResponseV3,
  nowIsoInstant: string = Instant.now().toString(),
): StaffProfileResponseEmployment | null => {
  const activeEmployment = profile.employments.find(
    (employment) => employment.isActive,
  );
  if (activeEmployment) return activeEmployment;

  const now = toInstant(nowIsoInstant);
  if (now == null) return null;

  return findClosestUpcomingEmployment(profile.employments, now) ?? null;
};
